module.exports = __webpack_public_path__ + "img/MX-B12440-A-HQ.bf6f5ccb.png";